import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'
export default class MessageInternalTemplate extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/message/internal/template'
    super(store, path)
  }
}
